// extracted by mini-css-extract-plugin
export default {"wrapper":"checkbox-module--wrapper--bd0d9","input":"checkbox-module--input--fce06","checkmark":"checkbox-module--checkmark--d91c3"};